import React, { useEffect, useState, useRef } from 'react';
import './PublicCaCalender.css';

const MONTHS = [
  { value: 'january', label: 'Jan' },
  { value: 'february', label: 'Feb' },
  { value: 'march', label: 'Mar' },
  { value: 'april', label: 'Apr' },
  { value: 'may', label: 'May' },
  { value: 'june', label: 'Jun' },
  { value: 'july', label: 'Jul' },
  { value: 'august', label: 'Aug' },
  { value: 'september', label: 'Sep' },
  { value: 'october', label: 'Oct' },
  { value: 'november', label: 'Nov' },
  { value: 'december', label: 'Dec' },
];

const getYearOptions = () => {
  const y = new Date().getFullYear();
  return Array.from({ length: 4 }, (_, i) => ({ value: y - i, label: String(y - i) }));
};

const yearOptions = getYearOptions();
const getCurrentMonth = () => MONTHS[new Date().getMonth()].value;
const getCurrentYear = () => new Date().getFullYear();

export default function Calender({
  setCalender, calender, setSelectedYears, setSelectedMonths,
  selectedYears, selectedMonths, newloader, scrollContainerRef,
  categories = [], activeKeyword = '', activeIndex = 0,
  setActiveKeyword, setActiveIndex
}) {
  const [themeOpen, setThemeOpen] = useState(false);
  const [monthOpen, setMonthOpen] = useState(false);
  const [yearOpen, setYearOpen] = useState(false);
  const themeRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);
  const didMount = useRef(false);

  useEffect(() => {
    const handler = (e) => {
      if (themeRef.current && !themeRef.current.contains(e.target)) setThemeOpen(false);
      if (monthRef.current && !monthRef.current.contains(e.target)) setMonthOpen(false);
      if (yearRef.current && !yearRef.current.contains(e.target)) setYearOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  useEffect(() => {
    const el = scrollContainerRef?.current;
    if (!el) return;
    const close = () => { setMonthOpen(false); setYearOpen(false); };
    el.addEventListener('scroll', close, { passive: true });
    return () => el.removeEventListener('scroll', close);
  }, [scrollContainerRef]);

  useEffect(() => {
    if (!didMount.current) {
      if (selectedMonths.length === 0) setSelectedMonths([getCurrentMonth()]);
      if (selectedYears.length === 0) setSelectedYears([getCurrentYear()]);
      didMount.current = true;
    }
  }, []);

  useEffect(() => {
    if (selectedMonths.length > 0 && selectedYears.length > 0) {
      setCalender({
        date_filter: 'all',
        body: { years: selectedYears, months: selectedMonths, keywords: [] }
      });
    }
  }, [selectedMonths, selectedYears, setCalender]);

  const selectTheme = (name, index) => {
    if (setActiveKeyword) setActiveKeyword(name === 'All' ? '' : name);
    if (setActiveIndex) setActiveIndex(index);
    setThemeOpen(false);
  };

  const toggleMonth = (value) => {
    setSelectedMonths(prev =>
      prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
    );
  };

  const selectYear = (value) => {
    setSelectedYears([value]);
    setYearOpen(false);
  };

  const removeMonth = (value, e) => {
    e.stopPropagation();
    setSelectedMonths(prev => prev.filter(v => v !== value));
  };

  const monthLabel = (value) => MONTHS.find(m => m.value === value)?.label || value;

  const currentTheme = categories[activeIndex]?.name || 'All';

  return (
    <div className="ca-filter-group">
      <div className="ca-dropdown" ref={themeRef}>
        <button
          className="ca-dropdown-trigger ca-theme-trigger"
          onClick={() => !newloader && setThemeOpen(p => !p)}
          disabled={newloader}
        >
          <svg className="ca-filter-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
          </svg>
          <span className="ca-theme-label">{currentTheme}</span>
          <span className={`ca-arrow ${themeOpen ? 'ca-arrow-up' : ''}`}>▾</span>
        </button>
        {themeOpen && (
          <div className="ca-dropdown-menu ca-theme-grid">
            {categories.map((cat, i) => {
              const sel = activeIndex === i;
              return (
                <div
                  key={cat.name}
                  className={`ca-theme-item ${sel ? 'ca-theme-item-selected' : ''}`}
                  onClick={() => selectTheme(cat.name, i)}
                >
                  <img src={cat.img} alt="" className="ca-theme-icon" />
                  <span className="ca-theme-name">{cat.name}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="ca-dropdown" ref={monthRef}>
        <button
          className="ca-dropdown-trigger"
          onClick={() => !newloader && setMonthOpen(p => !p)}
          disabled={newloader}
        >
          <div className="ca-chips">
            {selectedMonths.length === 0 && <span className="ca-placeholder">Month</span>}
            {selectedMonths.slice(0, 2).map(m => (
              <span key={m} className="ca-chip">
                {monthLabel(m)}
                <span className="ca-chip-remove" onClick={e => removeMonth(m, e)}>×</span>
              </span>
            ))}
            {selectedMonths.length > 2 && (
              <span className="ca-chip-more">+{selectedMonths.length - 2}</span>
            )}
          </div>
          <span className={`ca-arrow ${monthOpen ? 'ca-arrow-up' : ''}`}>▾</span>
        </button>
        {monthOpen && (
          <div className="ca-dropdown-menu ca-dropdown-grid">
            {MONTHS.map(m => {
              const sel = selectedMonths.includes(m.value);
              return (
                <div
                  key={m.value}
                  className={`ca-grid-item ${sel ? 'ca-grid-item-selected' : ''}`}
                  onClick={() => toggleMonth(m.value)}
                >
                  <span>{m.label}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="ca-dropdown" ref={yearRef}>
        <button
          className="ca-dropdown-trigger"
          onClick={() => !newloader && setYearOpen(p => !p)}
          disabled={newloader}
        >
          <span className="ca-year-label">{selectedYears[0] || 'Year'}</span>
          <span className={`ca-arrow ${yearOpen ? 'ca-arrow-up' : ''}`}>▾</span>
        </button>
        {yearOpen && (
          <div className="ca-dropdown-menu">
            {yearOptions.map(y => {
              const sel = selectedYears.includes(y.value);
              return (
                <div
                  key={y.value}
                  className={`ca-dropdown-item ${sel ? 'ca-dropdown-item-selected' : ''}`}
                  onClick={() => selectYear(y.value)}
                >
                  <span className={`ca-radio ${sel ? 'ca-radio-checked' : ''}`} />
                  <span>{y.label}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
